/**
 * @generated SignedSource<<a9879182f7f8a89d6702b7d483553bfb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "footerNewsletterId"
    }],
    v1 = [{
      "kind": "Literal",
      "name": "filter",
      "value": {
        "entityId": "scmp_pwa_widget"
      }
    }],
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    v3 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "json",
      "storageKey": null
    },
    v4 = [{
      "fields": [{
        "kind": "Variable",
        "name": "entityId",
        "variableName": "footerNewsletterId"
      }],
      "kind": "ObjectValue",
      "name": "filter"
    }],
    v5 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    v6 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    v7 = [{
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }],
    v8 = {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": v7 /*: any*/,
      "storageKey": null
    },
    v9 = {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": v7 /*: any*/,
      "storageKey": null
    },
    v10 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "footerDisplayQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [v2 /*: any*/, v3 /*: any*/],
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_widget\"})"
      }, {
        "alias": null,
        "args": v4 /*: any*/,
        "concreteType": "Newsletter",
        "kind": "LinkedField",
        "name": "newsletter",
        "plural": false,
        "selections": [v2 /*: any*/, v5 /*: any*/, v6 /*: any*/, v8 /*: any*/, v9 /*: any*/],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "footerDisplayQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [v2 /*: any*/, v3 /*: any*/, v10 /*: any*/],
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_widget\"})"
      }, {
        "alias": null,
        "args": v4 /*: any*/,
        "concreteType": "Newsletter",
        "kind": "LinkedField",
        "name": "newsletter",
        "plural": false,
        "selections": [v2 /*: any*/, v5 /*: any*/, v6 /*: any*/, v8 /*: any*/, v9 /*: any*/, v10 /*: any*/],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "aeccf4f9e4f975b246fac8ec525ecc1f",
      "id": null,
      "metadata": {},
      "name": "footerDisplayQuery",
      "operationKind": "query",
      "text": "query footerDisplayQuery(\n  $footerNewsletterId: String\n) {\n  appConfig(filter: {entityId: \"scmp_pwa_widget\"}) {\n    entityId\n    json\n    id\n  }\n  newsletter(filter: {entityId: $footerNewsletterId}) {\n    entityId\n    name\n    alternativeName\n    summary {\n      text\n    }\n    homepageDescription {\n      text\n    }\n    id\n  }\n}\n"
    }
  };
}();
node.hash = "88d7d054c9fb5b7bbe088e9d86c9ec22";
export default node;